// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__s_C6X"};